import { ShamDashboardData } from 'sham-components/features/dashboard';
import {
  ShamCashbackIcon,
  ShamComplaintIcon,
  ShamCoupon02Icon,
  ShamDashboardSquare01StrokeIcon,
  ShamDeliveryTruck01StrokeIcon,
  ShamInvoice03Icon,
  ShamInvoice04Icon,
  ShamLayers01Icon,
  ShamNews01Icon,
  ShamPackageIcon,
  ShamPackagingIcon,
  ShamSettingsIcon,
  ShamStore03Icon,
  ShamUsergroup03greyIcon,
  ShamWhiteboardIcon,
} from 'sham-components/icons';

export async function dashboardLayoutDataFactory(
  dashData: ShamDashboardData,
  translate: any,
) {
  dashData.navLinks.set([
    {
      name: translate.instant('menu.dashboard'), // استخدام المفتاح بدلاً من النص
      paths: 'dashboard',
      icon: ShamDashboardSquare01StrokeIcon,
    },
    'hr',
    {
      name: translate.instant('menu.user_management'),
      items: [
        {
          name: translate.instant('Customers'),
          paths: 'all-users',
          icon: ShamUsergroup03greyIcon,
        },
        {
          name: translate.instant('menu.sellers'),
          paths: 'sellers',
          icon: ShamStore03Icon,
        },
        {
          name: translate.instant('menu.delivery_drivers'),
          paths: 'delivery-drivers',
          icon: ShamDeliveryTruck01StrokeIcon,
        },
        {
          name: translate.instant('staff.title'),
          paths: 'staff',
          icon: ShamUsergroup03greyIcon,
        },
      ],
    },
    'hr',
    {
      name: translate.instant('menu.order_management'),
      items: [
        {
          name: translate.instant('menu.orders'),
          paths: 'orders',
          icon: ShamPackagingIcon,
        },
        {
          name: translate.instant('menu.payments'),
          paths: 'payments',
          icon: ShamInvoice04Icon,
        },
        {
          name: 'Refunds',
          paths: 'refunds',
          icon: ShamCashbackIcon,
        },
      ],
    },
    'hr',
    {
      name: translate.instant('menu.catalog'),
      items: [
        {
          name: translate.instant('menu.products'),
          paths: 'products',
          icon: ShamPackageIcon,
        },
        {
          name: translate.instant('menu.categories'),
          paths: 'categories',
          icon: ShamLayers01Icon,
        },
        { name: 'Reviews', paths: 'reviews', icon: ShamPackageIcon },
        {
          name: 'Reported Reviews',
          paths: 'reported-reviews',
          icon: ShamComplaintIcon,
        },
        { name: 'Options', paths: 'tags', icon: ShamCoupon02Icon },
        { name: 'Coupons', paths: 'coupons', icon: ShamCoupon02Icon },
      ],
    },
    'hr',
    {
      name: translate.instant('menu.reports'),
      paths: 'reports',
      icon: ShamWhiteboardIcon,
    },
    'hr',
    {
      name: 'General Setting',
      items: [
        {
          name: translate.instant('menu.privacy_policy'),
          paths: 'policy',
          icon: ShamNews01Icon,
        },
        {
          name: translate.instant('menu.terms_conditions'),
          paths: 'terms-and-condition',
          icon: ShamNews01Icon,
        },
        {
          name: 'General Settings',
          paths: 'general-settings',
          icon: ShamSettingsIcon,
        },
      ],
    },
    // 'hr',
    // {
    //   name: 'Logout',
    //   paths: 'logout',
    //   icon: ShamLayers01Icon, // استبدلها بأيقونة خروج
    // },
  ]);
}
